import { useToken } from '@chakra-ui/react';
import { useTranslations } from '@ui/i18n';
import { withNoSSR } from '@ui/utils/withNoSSR';
import { format } from 'date-fns';
import numbro from 'numbro';

import type { SimpleLineChartProps } from './SimpleLineChart';
import { SimpleLineChart } from './SimpleLineChart';

export type StrategyApySimpleLineChartProps = Partial<SimpleLineChartProps> & {
  apyList: {
    y: number;
    date: number;
  }[];
};
export const StrategyApySimpleLineChart = withNoSSR(
  ({ apyList, ...props }: StrategyApySimpleLineChartProps) => {
    const t = useTranslations();

    const [chartLineColor] = useToken('colors', ['brand-inactive']);

    return (
      <SimpleLineChart
        {...props}
        series={[
          {
            data: apyList.map(({ y, date }) => {
              return {
                y: y * 100,
                name: format(date, 'yyyy - MM - dd'),
              };
            }),
            color: chartLineColor,
            label: t('APY % plotted over time'),
          },
        ]}
        lineColorAlphaBase={0.4}
        height={100}
        tooltipFormatter={({ y }) => {
          return `${numbro(y).format({
            mantissa: 1,
            trimMantissa: true,
          })}%`;
        }}
      />
    );
  },
);
